import { supabase } from "@/integrations/supabase/client";
import { WebhookData } from "@/types/auth.types";

export const handleWebhookNotification = async (email: string) => {
  try {
    const { error } = await supabase.functions.invoke("send-confirmation-email", {
      body: { email, type: "welcome" }
    });
    
    if (error) {
      console.error("Error handling webhook notification:", error);
      throw error;
    }
    
    return { success: true };
  } catch (error) {
    console.error("Error in webhook notification:", error);
    throw error;
  }
};

export const initializeAuthSession = async () => {
  return await supabase.auth.getSession();
};

// We verwijderen deze functie omdat we de subscriber direct in AuthContext gaan maken
